import PRODUCT_LIST from '../../types/product-list'

export default {
  [PRODUCT_LIST.ACTIONS.CHANGE_PRICES]: ({commit}, payload) => {
    commit(PRODUCT_LIST.MUTATIONS.SET_PRODUCT_PRICE, payload)
  }
}
